import axios from "axios";

export default new (class {
  loadCollections(productType) {
    // let contactId = localStorage.getItem("contactId");
    let collectionsUrl = "/api/collections?product_type=" + productType;
    return axios({
      // baseUrl: '',
      method: "GET",
      url: collectionsUrl,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }
  checkShapeF(styleNumber) {
    if (styleNumber == "3_plus") {
      styleNumber = "3";
    }
    return styleNumber;
  }

  loadInitialProducts(productType, styleNumber = null) {
    var collectionUrl = "/api/products?product_type=" + productType;
    if (styleNumber) {
      styleNumber = this.checkShapeF(styleNumber);
      collectionUrl += "&style_number=" + styleNumber;
    }
    return axios({
      // baseUrl: '',
      method: "GET",
      url: collectionUrl,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  loadCollectionProducts(collection, styleNumber) {
    var collectionUrl = "/api/products?collection=" + collection.name;
    if (styleNumber) {
      styleNumber = this.checkShapeF(styleNumber);
      collectionUrl += "&style_number=" + styleNumber;
    }
    return axios({
      // baseUrl: '',
      method: "GET",
      url: collectionUrl,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  loadCollectionAssortment(collection) {
    var collectionUrl = "/api/collections/" + collection.id + "/assortment";
    return axios({
      // baseUrl: '',
      method: "GET",
      url: collectionUrl,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  loadProductRecommendations(product, shapeToken) {
    shapeToken = this.checkShapeF(shapeToken);
    return axios({
      // baseURL: '',
      method: "GET",
      url: "/api/products/" + product.id + "?style_number=" + shapeToken,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  identifyContact(contactId) {
    return axios({
      // baseURL: '',
      method: "GET",
      url: "/api/contact_requests/" + contactId,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  loadCollectionsByProductType(productType) {
    return axios({
      method: "GET",
      url: "/api/collections?product_type=" + productType,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }

  loadPersonalizedProducts(productType, styleNumber) {
    styleNumber = this.checkShapeF(styleNumber);
    return axios({
      method: "GET",
      url:
        "/api/products/personalized?product_type=" +
        productType +
        "&style_number=" +
        styleNumber,
      responseType: "json",
    }).then((response) => {
      return response.data;
    });
  }
})();
